function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSectionchevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 80,
    viewBox: "0 0 32 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.732 3.036a1 1 0 011.232.696l10 36a.999.999 0 010 .536l-10 36a1 1 0 01-1.928-.536L19.962 40 10.037 4.268a1 1 0 01.695-1.232z",
    fill: props.fill
  }));
}

export default SvgSectionchevron;